import { render, staticRenderFns } from "./TabsOnlyComponent.vue?vue&type=template&id=2e0f1e89&scoped=true"
import script from "./TabsOnlyComponent.vue?vue&type=script&lang=js"
export * from "./TabsOnlyComponent.vue?vue&type=script&lang=js"
import style0 from "./TabsOnlyComponent.vue?vue&type=style&index=0&id=2e0f1e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0f1e89",
  null
  
)

export default component.exports